import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Constants} from "../../constants";

@Injectable({
  providedIn: 'root'
})
export class StatsService {

  constructor(private http: HttpClient) {
  }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: environment.publicApiToken,
    });
  }

  async getCompanyStatsTotal() {
    let response: any;

    try {
      response = await this.http.get(environment.apiUrl + '/stats/companies/totals', {
        headers: this.getRequestHeaders(),
      }).toPromise();

      /*if (response.success) {
        stats = response.data
      }*/
    } catch (e) {
      console.error('error getting pendingCompanies: ', e)
    } finally {
      return response;
    }
  }
  async getCompanyStats(companyId: any) {
    let response: any;
    try {
      response = await this.http.get(environment.apiUrl + `/stats/companies/totals/${companyId}`, {
        headers: this.getRequestHeaders(),
      }).toPromise();

    } catch (e) {
      console.error('error getting pendingCompanies: ', e)
    } finally {
      return response;
    }
  }

  async getAdminStatsTotal() {
    let response: any;

    try {
      response = await this.http.get(environment.apiUrl + '/stats/admin/totals', {
        headers: this.getRequestHeaders()
      }).toPromise();

      /*if (response.success) {
        stats = response.data
      }*/
    } catch (e) {
      console.error('error getting pendingCompanies: ', e)
    } finally {
      return response;
    }
  }

  async getAgentStatsTotal(agentId: any) {
    let response: any;
    try {
      response = await this.http.get(environment.apiUrl + '/stats/agent/totals/' + agentId, {
        headers: this.getRequestHeaders()
      }).toPromise();
    } catch (e) {
      console.error('error getting pendingCompanies: ', e)
    } finally {
      return response;
    }
  }
}
